const dateFormatter = (dateString: string, timeZone?: string) => {
  const date = new Date(dateString);
  const options: Intl.DateTimeFormatOptions = {
    day: '2-digit',
    month: 'short',
    year: 'numeric',
    timeZone,
  };
  const formattedDate = date.toLocaleDateString('en-US', options);
  return formattedDate;
};

export default dateFormatter;
